import * as API from './api'
import * as Types from './Types'

export function tryGetLaundrySystem(token, communityId) {
  return dispatch => {
    dispatch({
      type: Types.GET_LAUNDRY_BOOKING_SYSTEM
    })

    API.getLaundrySystem(token, communityId)
      .then(response => {
        dispatch({
          type: Types.GET_LAUNDRY_BOOKING_SYSTEM_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        dispatch({
          type: Types.GET_LAUNDRY_BOOKING_SYSTEM_FAILED,
          payload: 500
        })
      })
  }
}

export function tryGetInformationItems(token, communityId) {
  return dispatch => {
    dispatch({
      type: Types.GET_INFORMATION_ITEMS
    })

    API.getInformationItems(token, communityId)
      .then(response => {
        dispatch({
          type: Types.GET_INFORMATION_ITEMS_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        dispatch({
          type: Types.GET_INFORMATION_ITEMS_FAILED,
          payload: 500
        })
      })
  }
}

export function tryGetPosts(token, communityId) {
  return dispatch => {
    dispatch({
      type: Types.GET_POSTS
    })

    API.getPosts(token, communityId)
      .then(response => {
        dispatch({
          type: Types.GET_POSTS_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        dispatch({
          type: Types.GET_POSTS_FAILED,
          payload: 500
        })
      })
  }
}

export function tryGetBookingSystem(token, communityId) {
  return dispatch => {
    dispatch({
      type: Types.GET_BOOKING_SYSTEM,
      payload: communityId
    })

    API.getBookingSystem(token, communityId)
      .then(response => {
        dispatch({
          type: Types.GET_BOOKING_SYSTEM_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        dispatch({
          type: Types.GET_BOOKING_SYSTEM_FAILED,
          payload: 500
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/Data.js